import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa"; // Social Icons
import { Link } from "react-router-dom";
import './Footer.css';

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#0A1E3F",
        color: "white",
        padding: "40px 0",
        textAlign: "center",
      }}
    >
      <Container>
        <Row className="align-items-center">
          {/* Left Section - Logo & Description */}
          <Col md={4} className="text-md-start text-center">
            <img
              src="/NAEW1.png"
              alt="New Age Engineering World"
              width="100" // Smaller Logo Size
              className="mb-2"
            />
            <h5 className="mt-2">New Age Engineering World</h5>
            <p style={{ fontSize: "14px", maxWidth: "250px" }}>
              A hub of engineering expertise and innovation aimed at creating value.
            </p>
            <p className="mt-3" style={{ fontSize: "12px" }}>
              © 2024 New Age Engineering World Pvt. Ltd.
            </p>
          </Col>

          {/* Quick Links - Moved to Rightmost Corner */}
          <Col md={4}></Col> {/* Empty Column to Push Quick Links to the Right */}
          <Col md={4} className="text-md-end text-center">
            <h6 className="fw-bold">Quick Links</h6>
            <ul style={{ listStyle: "none", padding: 0, textAlign: "right" }}>
              <li><Link to="/" className="footer-link">Home</Link></li>
              
              <li><Link to="/services" className="footer-link">Our Services</Link></li>
              <li><Link to="/gallery" className="footer-link">Gallery</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </Col>
        </Row>

        {/* Social Media Icons - Centered at Bottom */}
        <div className="social-icons mt-4">
          <a
            href="https://www.facebook.com/share/1BqeZGdE36/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://x.com/new_age_2022"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <FaTwitter />
          </a>
          <a
            href="https://www.linkedin.com/company/new-age-engineering-world/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
